export default __webpack_public_path__ + "static/media/insta.b8142cc7.svg";